"use strict";

import {tutils, PropTypes, resolvers} from "Subschema";
const {resolveKey} = tutils;
import _omit from "lodash/Object/omit";

function resolve(value, key, props, {valueManager, noValidate}) {
	if (typeof value === 'function') {
		return value;
	}
	const resolvedPath = props.name || resolveKey(props.path, value);
	return function targetEvent$resolve(e, validate = true) {
		const value = valueManager.getValue();
		let errors = valueManager.getErrors();
		if (errors) {
			if (errors["global.error"]) {
				delete errors["global.error"];
			}
			if (errors["global.success"]) {
				delete errors["global.success"];
			}
			if (errors["global.warning"]) {
				delete errors["global.warning"];
			}
			valueManager.setErrors(errors);
		}
		if (!noValidate && validate) {
			valueManager.validate(null, value);
			errors = valueManager.getErrors();
		} else {
			errors = null;
		}
		errors = errors && _omit(errors, Object.keys(errors).reduce((result, key) => {
			let errArray = errors[key].filter((e) => e.type === 'success');
			if (errArray.length > 0) {
				result.push(key);
			}
			return result;
		}, []));
		valueManager.onSubmit(e, errors, value, resolvedPath);
	}
}
export default function submit(Clazz, key) {
	Clazz.contextTypes.valueManager = PropTypes.valueManager;
	Clazz.contextTypes.noValidate = PropTypes.bool;
	Clazz::this.property(key, resolve)
}


/** WEBPACK FOOTER **
 ** ./src/resolver/submit.js
 **/